export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "http://0.0.0.0:3001";
